import React, { useMemo, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Pagination,
  InputGroup,
  Form
} from 'react-bootstrap';

const CommissionReports = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const [searchQuery, setSearchQuery] = useState('');

  const commissionData = [
    {
      id: 'CMP001',
      date: '2024-11-05',
      mobile: '9876543210',
      status: 'Settled',
      amount: 1250.0,
      serviceCharges: 15.75,
      baseRate: 1180.0,
      retailerCommission: 70.0,
      retailerTds: 7.0,
      distributorCommission: 15.0,
      masterDistributorCommission: 10.0,
      netCommission: 63.0,
      service: 'AEPS',
      retailerShop: 'Digital Mart',
      retailerName: 'Rajesh Kumar',
      retailerMobile: '9876543210',
      retailerPan: 'ABCDE1234F'
    },
    {
      id: 'CMP002',
      date: '2024-11-05',
      mobile: '9123456789',
      status: 'Pending',
      amount: 780.0,
      serviceCharges: 10.0,
      baseRate: 750.0,
      retailerCommission: 30.0,
      retailerTds: 3.0,
      distributorCommission: 8.0,
      masterDistributorCommission: 5.0,
      netCommission: 27.0,
      service: 'Recharge',
      retailerShop: 'Quick Recharge Hub',
      retailerName: 'Priya Sharma',
      retailerMobile: '9123456789',
      retailerPan: 'PQRSX6789Z'
    },
    {
      id: 'CMP003',
      date: '2024-11-04',
      mobile: '8765432109',
      status: 'Settled',
      amount: 1590.0,
      serviceCharges: 20.0,
      baseRate: 1500.0,
      retailerCommission: 90.0,
      retailerTds: 9.0,
      distributorCommission: 18.0,
      masterDistributorCommission: 12.0,
      netCommission: 81.0,
      service: 'Payout',
      retailerShop: 'Fintech Plus',
      retailerName: 'Amit Patel',
      retailerMobile: '8765432109',
      retailerPan: 'LMNOP3456Q'
    },
    {
      id: 'CMP004',
      date: '2024-11-04',
      mobile: '9988776655',
      status: 'Settled',
      amount: 950.0,
      serviceCharges: 8.0,
      baseRate: 900.0,
      retailerCommission: 50.0,
      retailerTds: 5.0,
      distributorCommission: 12.0,
      masterDistributorCommission: 8.0,
      netCommission: 45.0,
      service: 'DTH',
      retailerShop: 'Sky Connect',
      retailerName: 'Sneha Reddy',
      retailerMobile: '9988776655',
      retailerPan: 'BCDEF1122G'
    },
    {
      id: 'CMP005',
      date: '2024-11-04',
      mobile: '7654321098',
      status: 'Pending',
      amount: 2100.0,
      serviceCharges: 18.0,
      baseRate: 2000.0,
      retailerCommission: 100.0,
      retailerTds: 10.0,
      distributorCommission: 20.0,
      masterDistributorCommission: 12.0,
      netCommission: 90.0,
      service: 'Bill Payment',
      retailerShop: 'Urban Pay Center',
      retailerName: 'Vikram Singh',
      retailerMobile: '7654321098',
      retailerPan: 'ABCDE5678L'
    },
    {
      id: 'CMP006',
      date: '2024-11-03',
      mobile: '9876543211',
      status: 'Settled',
      amount: 3200.0,
      serviceCharges: 25.0,
      baseRate: 3050.0,
      retailerCommission: 150.0,
      retailerTds: 15.0,
      distributorCommission: 28.0,
      masterDistributorCommission: 18.0,
      netCommission: 135.0,
      service: 'Insurance',
      retailerShop: 'Secure Life Kiosk',
      retailerName: 'Anjali Gupta',
      retailerMobile: '9876543211',
      retailerPan: 'GHJKL2345M'
    },
    {
      id: 'CMP007',
      date: '2024-11-03',
      mobile: '8899776655',
      status: 'Pending',
      amount: 1850.0,
      serviceCharges: 16.0,
      baseRate: 1780.0,
      retailerCommission: 70.0,
      retailerTds: 7.0,
      distributorCommission: 14.0,
      masterDistributorCommission: 9.0,
      netCommission: 63.0,
      service: 'UPI Collect',
      retailerShop: 'Digital Wallet Hub',
      retailerName: 'Rahul Verma',
      retailerMobile: '8899776655',
      retailerPan: 'RSTUV7890W'
    },
    {
      id: 'CMP008',
      date: '2024-11-02',
      mobile: '7788996655',
      status: 'Settled',
      amount: 640.0,
      serviceCharges: 6.0,
      baseRate: 600.0,
      retailerCommission: 40.0,
      retailerTds: 4.0,
      distributorCommission: 9.0,
      masterDistributorCommission: 6.0,
      netCommission: 36.0,
      service: 'Mobile Recharge',
      retailerShop: 'TalkTime Express',
      retailerName: 'Neha Joshi',
      retailerMobile: '7788996655',
      retailerPan: 'UVWXY3456Z'
    },
    {
      id: 'CMP009',
      date: '2024-11-02',
      mobile: '9966554433',
      status: 'On Hold',
      amount: 2750.0,
      serviceCharges: 22.0,
      baseRate: 2600.0,
      retailerCommission: 150.0,
      retailerTds: 15.0,
      distributorCommission: 30.0,
      masterDistributorCommission: 20.0,
      netCommission: 135.0,
      service: 'Flight Booking',
      retailerShop: 'Travel Booking Hub',
      retailerName: 'Suresh Yadav',
      retailerMobile: '9966554433',
      retailerPan: 'ABCDE9012P'
    },
    {
      id: 'CMP010',
      date: '2024-11-02',
      mobile: '8877665544',
      status: 'Settled',
      amount: 5120.0,
      serviceCharges: 30.0,
      baseRate: 4900.0,
      retailerCommission: 220.0,
      retailerTds: 22.0,
      distributorCommission: 35.0,
      masterDistributorCommission: 25.0,
      netCommission: 198.0,
      service: 'Loan Repayment',
      retailerShop: 'Finance Point',
      retailerName: 'Kavita Mehta',
      retailerMobile: '8877665544',
      retailerPan: 'LMNOP6789Q'
    },
    {
      id: 'CMP011',
      date: '2024-11-01',
      mobile: '9876543212',
      status: 'Settled',
      amount: 890.0,
      serviceCharges: 7.0,
      baseRate: 850.0,
      retailerCommission: 40.0,
      retailerTds: 4.0,
      distributorCommission: 10.0,
      masterDistributorCommission: 7.0,
      netCommission: 36.0,
      service: 'Broadband',
      retailerShop: 'Connect Online',
      retailerName: 'Arun Kumar',
      retailerMobile: '9876543212',
      retailerPan: 'ABCDE3333R'
    },
    {
      id: 'CMP012',
      date: '2024-11-01',
      mobile: '9123456788',
      status: 'Pending',
      amount: 3400.0,
      serviceCharges: 24.0,
      baseRate: 3250.0,
      retailerCommission: 150.0,
      retailerTds: 15.0,
      distributorCommission: 28.0,
      masterDistributorCommission: 18.0,
      netCommission: 135.0,
      service: 'AEPS',
      retailerShop: 'Rural Banking Center',
      retailerName: 'Pooja Singh',
      retailerMobile: '9123456788',
      retailerPan: 'ABCDE2468T'
    },
    {
      id: 'CMP013',
      date: '2024-11-01',
      mobile: '8765432108',
      status: 'Settled',
      amount: 1320.0,
      serviceCharges: 12.0,
      baseRate: 1260.0,
      retailerCommission: 60.0,
      retailerTds: 6.0,
      distributorCommission: 14.0,
      masterDistributorCommission: 9.0,
      netCommission: 54.0,
      service: 'Gas Booking',
      retailerShop: 'Utility Care',
      retailerName: 'Deepak Sharma',
      retailerMobile: '8765432108',
      retailerPan: 'ABCDE5566U'
    },
    {
      id: 'CMP014',
      date: '2024-10-31',
      mobile: '9988776656',
      status: 'Settled',
      amount: 740.0,
      serviceCharges: 6.5,
      baseRate: 700.0,
      retailerCommission: 40.0,
      retailerTds: 4.0,
      distributorCommission: 9.0,
      masterDistributorCommission: 6.0,
      netCommission: 36.0,
      service: 'DTH',
      retailerShop: 'Prime Dish Center',
      retailerName: 'Ritu Agarwal',
      retailerMobile: '9988776656',
      retailerPan: 'FGHIJ7788V'
    },
    {
      id: 'CMP015',
      date: '2024-10-31',
      mobile: '7654321099',
      status: 'Settled',
      amount: 1040.0,
      serviceCharges: 9.0,
      baseRate: 1000.0,
      retailerCommission: 40.0,
      retailerTds: 4.0,
      distributorCommission: 10.0,
      masterDistributorCommission: 6.0,
      netCommission: 36.0,
      service: 'Recharge',
      retailerShop: 'Quick Talk Store',
      retailerName: 'Manoj Tiwari',
      retailerMobile: '7654321099',
      retailerPan: 'ABCDE7788W'
    }
  ];

  const filteredData = useMemo(() => {
    if (!searchQuery) {
      return commissionData;
    }

    return commissionData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [commissionData, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => `₹${value.toFixed(2)}`;

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="commission-reports-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Commission Reports
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {[
                        'Date',
                        'Mobile No.',
                        'Order ID',
                        'Txn Type',
                        'Amount',
                        'Service Charge',
                        'Commission',
                        'TDS',
                        'Status'
                      ].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((row) => (
                        <tr key={row.id} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{row.date}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 500 }}>{row.mobile}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{row.id}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{row.service}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(row.amount)}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{formatCurrency(row.serviceCharges)}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{formatCurrency(row.retailerCommission)}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{formatCurrency(row.retailerTds)}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{row.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center py-4" style={{ color: '#999' }}>
                          No commission records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredData.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .commission-reports-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default CommissionReports;


